import React from 'react'


const DashboardStatistics = ({ t,booking }) => {
  return (
    <section className="section-dashboard-cards mb-3">
      <div className="row g-2">
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="d-card d-card-primary">
            <div className="d-card-header">{t("totalBookings")}</div>
            <div className="d-card-body">
              <div className="d-card-body-1">
                <span>{booking?.total || 0}</span>
                <span>{t("newThisMonth")}: {booking?.thisMonthTotal || 0}</span>
              </div>
              <div className="d-card-body-2 d-none">
                <span>52.0%</span>
                <i className="fas fa-arrow-circle-up"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="d-card d-card-dark">
            <div className="d-card-header">{t("pendingBookings")}</div>
            <div className="d-card-body">
              <div className="d-card-body-1">
                <span>{booking?.pending || 0}</span>
                <span>{t("newThisMonth")}: {booking?.thisMonthPending || 0}</span>
              </div>
              <div className="d-card-body-2 d-none">
                <span>52.0%</span>
                <i className="fas fa-arrow-circle-up"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="d-card d-card-primary">
            <div className="d-card-header">{t("completedBookings")}</div>
            <div className="d-card-body">
              <div className="d-card-body-1">
                <span>{booking?.completed || 0}</span>
                <span>{t("newThisMonth")}: {booking?.thisMonthCompleted || 0}</span>
              </div>
              <div className="d-card-body-2 d-none">
                <span>52.0%</span>
                <i className="fas fa-arrow-circle-up"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div className="d-card d-card-dark">
            <div className="d-card-header">{t("totalRevenue")}</div>
            <div className="d-card-body">
              <div className="d-card-body-1">
                <span>{booking?.totalRevenue || 0}</span>
                <span>{t("thisMonth")}: {booking?.thisMonthRevenue || 0}</span>
              </div>
              <div className="d-card-body-2 d-none">
                <span>52.0%</span>
                <i className="fas fa-arrow-circle-up"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DashboardStatistics